import { useState } from "react";
import { api } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Briefcase, Send } from "lucide-react";

export default function HireMeButton({ username, creatorName }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "", budget: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post(`/users/${username}/hire`, form);
      toast.success(
        data.email_sent
          ? `Message sent — ${creatorName} will reply to ${form.email}.`
          : `Message delivered to ${creatorName}'s inbox.`
      );
      setForm({ name: "", email: "", message: "", budget: "" });
      setOpen(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to send");
    } finally { setLoading(false); }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 rounded-full border border-[hsl(var(--accent))] text-[hsl(var(--accent))] hover:bg-[hsl(var(--accent))] hover:text-white px-4 py-1.5 text-xs font-mono-u uppercase tracking-widest transition-colors"
        data-testid="hire-me-btn"
      >
        <Briefcase className="h-3.5 w-3.5" /> Hire me
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="hire-dialog">
          <DialogHeader>
            <DialogTitle>Reach out to {creatorName}</DialogTitle>
            <DialogDescription>Share a bit about your project. {creatorName} will reply to your email directly.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <div><Label>Your name</Label><Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="hire-name" /></div>
            <div><Label>Your email</Label><Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="hire-email" /></div>
            <div><Label>Budget (optional)</Label><Input placeholder="e.g. $2–5k, flexible" value={form.budget} onChange={(e) => setForm({ ...form, budget: e.target.value })} data-testid="hire-budget" /></div>
            <div><Label>Message</Label><Textarea required rows={5} placeholder="Project scope, timeline, references…" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="hire-message" /></div>
            <DialogFooter>
              <Button type="submit" disabled={loading} className="bg-[hsl(var(--accent))] hover:bg-[hsl(15_100%_55%)] text-white gap-2" data-testid="hire-submit">
                {loading ? "Sending…" : (<><Send className="h-4 w-4" /> Send to {creatorName}</>)}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
